import { cloneDeep } from "lodash";
import {
  fetchInboxNotificationsService,
  seenInboxNotificationsService,
} from "./inboxServices";

export const fetchInboxNotifications =
  (isOnScroll, offset, inboxData) => dispatch =>
    new Promise((resolve, reject) => {
      fetchInboxNotificationsService(offset)
        .then(response => {
          const resData = response.Notifications;
          if (isOnScroll) {
            const inboxDataClone = cloneDeep(inboxData);
            const updatedInboxData = Object.assign({}, resData);
            updatedInboxData.notifications =
              inboxDataClone.notifications.concat(resData.notifications);
            dispatch({
              type: "FETCH_INBOX_NOTIFICATIONS_ON_SCROLL",
              payload: updatedInboxData,
            });
          } else {
            dispatch({
              type: "INBOX_INIT_DATA",
              payload: resData,
            });
          }

          resolve(response);
        })
        .catch(error => {
          console.error(`inboxActions => fetchInboxNotifications => ${error}`);
          reject(error);
        });
    });

export const seenInboxNotifications = () => dispatch =>
  new Promise((resolve, reject) => {
    seenInboxNotificationsService()
      .then(response => {
        dispatch({
          type: "INBOX_SEEN_UNSEEN_NOTIFICATIONS",
          payload: response.unseen_notifications,
        });
        resolve(response);
      })
      .catch(error => {
        console.error(`inboxActions => seenInboxNotifications => ${error}`);
        reject(error);
      });
  });
